import * as actions from "./actions";
import _ from "underscore";

let initialState = {
  withdraw: {
    fetching: false,
    fetched: false,
    fetchError: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },
  approve: {
    error: null,
    response: null,
    dataSent: null,
  },
  placeWithdrawal: {
    error: null,
    sending: false,
    sent: false,
  },
};

const borrowerOrders = (state = initialState, action) => {
  switch (action.type) {
    // GET ORDERS
    case actions.BORROWER_WITHDRAW_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        withdraw: Object.assign({}, state.withdraw, {
          fetching: true,
          fetchError: null,
          data: [],
        }),
      });
    case actions.BORROWER_WITHDRAW_LIST_GET_SUCCESS:
      return Object.assign({}, state, {
        withdraw: Object.assign({}, state.withdraw, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    case actions.BORROWER_WITHDRAW_LIST_GET_ERROR:
      return Object.assign({}, state, {
        withdraw: Object.assign({}, state.withdraw, {
          fetching: false,
          fetchError: action.error,
        }),
      });

    // Approve and cancel withdrawals
    case actions.APPROVE_BORROWER_WITHDRAWAL_ORDER_SUCCESS: {
      // After approval the deposit is then removed from the list
      let orderToRemoveIndex = _.findIndex(state.withdraw.data, (order) => {
        return order.Id === action.dataSent.OrderId;
      });
      return Object.assign({}, state, {
        withdraw: Object.assign({}, state.withdraw, {
          data: [
            ...state.withdraw.data.slice(0, orderToRemoveIndex),
            ...state.withdraw.data.slice(orderToRemoveIndex + 1),
          ],
        }),
      });
    }

    default:
      return state;
  }
};

export default borrowerOrders;
